import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DeadlineMonthTypeEnum } from '@zaoblako/shared/common/enums/deadline.month.type.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { DeadlineMonthTypeNamePipe } from '@zaoblako/web/shared/pipes/deadline-month-type-name.pipe';

@Component({
  standalone: true,
  selector: 'crm-deadline-month-type-single-select',
  templateUrl: './deadline-month-type-single-select.component.html',
  imports: [CommonModule, SingleSelectComponent, DeadlineMonthTypeNamePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeadlineMonthTypeSingleSelectComponent {
  @Input() public type: DeadlineMonthTypeEnum;
  @Output() public typeChange = new EventEmitter<DeadlineMonthTypeEnum>();

  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public appendTo: string;

  public options = Object.values(DeadlineMonthTypeEnum);
}
